<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6645 20L6.66545 16.25V11.9833L0 4.48333V2.5C0 1.83696 0.263344 1.20107 0.7321 0.732233C1.20086 0.263392 1.83662 0 2.49955 0L15.8305 0C16.4934 0 17.1291 0.263392 17.5979 0.732233C18.0667 1.20107 18.33 1.83696 18.33 2.5V4.48333L11.6645 11.9833V20Z"/>
  </svg>
</template>